import {
  faUser,
  faEye,
  faEnvelope,
  faArrowAltCircleLeft,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MenuItem } from "react-pro-sidebar";
import { Link } from "react-router-dom";
import Layout from "../components/Layout";
import { ProductSubscriptionGuard } from "../components/ProductSubscriptionGuard";
import { QuickSightDashboardEmbedWrapper } from "../components/QuickSightEmbed/QuickSightDashboardEmbedWrapper";
import SecureRoute from "../components/SecureRoute";
import { DefaultSidebarBreakpoint } from "../components/SidebarToggle";
import { ContactUs } from "../pages/contactus/ContactUs";
import { SignOut } from "../pages/sign-out/SignOut";
import { SubdomainOrgIdObject } from "./FunctionsAndInterfaces";

const orgId: number = 741418449;
const subDomain: string = "dashboard";
const nameOfProduct: string = "HMDA";
const secureRouteGroups: string[] = ["enduser"];

export const hmdaObject: SubdomainOrgIdObject = {
  orgID: orgId,
  path: subDomain,
};

const sidebarMenu = () => {
  return (
    <>
      <MenuItem>
        <Link to={`${subDomain}/marketoverview`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faUser} />
            Market Overview
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`${subDomain}/individuallender`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faEye} />
            Individual Lender{" "}
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`${subDomain}/contactus`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faEnvelope} />
            Contact Us
          </div>
        </Link>
      </MenuItem>
      <MenuItem>
        <Link to={`${subDomain}/signout`}>
          <div className="sidebar-item">
            <FontAwesomeIcon className="me-2" icon={faArrowAltCircleLeft} />
            Log Out
          </div>
        </Link>
      </MenuItem>
    </>
  );
};

export const hmdaRoutes = {
  element: (
    <Layout
      breakPoint={DefaultSidebarBreakpoint}
      smallHeader={true}
      sidebarMenu={sidebarMenu()}
      contactUsPath={`/${subDomain}/contactus`}
      signOutPath={`/${subDomain}/signout`}
    />
  ),
  children: [
    {
      path: `/${subDomain}/`,
      element: (
        <ProductSubscriptionGuard product="HMDA">
          <SecureRoute
            productName={nameOfProduct}
            groups={secureRouteGroups}
            element={
              <QuickSightDashboardEmbedWrapper
                initialDashboardId="da384f57-767e-48b3-be4d-d398a98aef0f"
                authorizedResourceArns={[
                  "arn:aws:quicksight:us-east-1:482021788001:dashboard/da384f57-767e-48b3-be4d-d398a98aef0f",
                ]}
              />
            }
          />
        </ProductSubscriptionGuard>
      ),
    },
    {
      path: `/${subDomain}/marketoverview`,
      element: (
        <ProductSubscriptionGuard product="HMDA">
          <SecureRoute
            productName={nameOfProduct}
            groups={secureRouteGroups}
            element={
              <QuickSightDashboardEmbedWrapper
                initialDashboardId="da384f57-767e-48b3-be4d-d398a98aef0f"
                authorizedResourceArns={[
                  "arn:aws:quicksight:us-east-1:482021788001:dashboard/da384f57-767e-48b3-be4d-d398a98aef0f",
                ]}
              />
            }
          />
        </ProductSubscriptionGuard>
      ),
    },
    {
      path: `/${subDomain}/individuallender`,
      element: (
        <ProductSubscriptionGuard product="HMDA">
          <SecureRoute
            productName={nameOfProduct}
            groups={secureRouteGroups}
            element={
              <QuickSightDashboardEmbedWrapper
                initialDashboardId="c7b36e46-fd24-4eec-a0ca-d6a16386807c"
                authorizedResourceArns={[
                  "arn:aws:quicksight:us-east-1:482021788001:dashboard/c7b36e46-fd24-4eec-a0ca-d6a16386807c",
                ]}
              />
            }
          />
        </ProductSubscriptionGuard>
      ),
    },
    {
      path: `/${subDomain}/contactus`,
      element: <ContactUs />,
    },
    {
      path: `/${subDomain}/signout`,
      element: <SignOut />,
    },
  ],
};
